// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/img/icons/marevo-icon-close.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/img/icons/mood-light-active.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../public/img/icons/led-light-active.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../public/img/icons/marevo-menu-sliding.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../public/img/icons/marevo-menu-blinds-active.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../public/img/icons/marevo-menu-shutters-sliding-active.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../public/img/icons/marevo-menu-door-sliding-glass-active.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../public/img/icons/marevo-menu-roof-settings-active.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.colors_picker_container {
  gap: 21px;
  display: inline-flex;
  align-items: center;
}
.colors_picker_container .colors_picker_color {
  width: 50px;
  height: 37px;
  cursor: pointer;
}
.colors_picker_container .type_interface_colors-buttons-led {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}
.colors_picker_container .colors_container {
  display: grid;
  width: 113px;
  grid-template-columns: repeat(5, 1fr);
  gap: 44px;
  justify-content: center;
}
.colors_picker_container__options {
  display: flex;
  gap: 16px;
}
.colors_picker_container__item--active:hover {
  transform: translateY(0) !important;
}
.colors_picker_container__item--active .image-container {
  padding: 2px;
}
.colors_picker_container__item--active .image-container::before {
  content: "";
  border: 0.5px solid rgba(98, 154, 51, 0.7) !important;
  position: absolute;
  width: 29px;
  height: 29px;
  border-radius: 50%;
}
.colors_picker_container__item--active .type_interface_colors-buttons-led__label {
  color: #629A33;
}
.colors_picker_container__label {
  display: flex;
  flex-direction: column;
  align-items: center !important;
  cursor: pointer;
  width: fit-content;
  font-weight: 400;
  font-size: 8px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: bottom;
}
.colors_picker_container__label .color-name {
  margin-top: 10px;
  text-align: center;
  font-family: "Inter", serif;
  font-weight: 400;
  font-size: 8px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: bottom;
}
.colors_picker_container .image-container {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  padding: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0.5px solid #1A1A1A;
  transition: all 0.3s;
}
.colors_picker_container .image-container .color-image {
  width: 100%;
  height: 100%;
  font-family: "Inter", serif;
  font-weight: 400;
  font-size: 8px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: bottom;
}

.colorShade {
  color: #629A33;
}

.type_interface_retrect-buttons-louvers__options {
  display: flex;
  gap: 16px;
  flex-direction: column;
  font-family: "Inter", serif;
  margin-top: 16px;
}
.type_interface_retrect-buttons-louvers__item {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}
.type_interface_retrect-buttons-louvers__item .type_interface_retrect-buttons-louvers__input {
  display: none;
}
.type_interface_retrect-buttons-louvers__item .radio-circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #629A33;
  display: inline-block;
  position: relative;
  flex-shrink: 0;
}
.type_interface_retrect-buttons-louvers__item .radio-circle::after {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #629A33;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: opacity 0.2s;
}
.type_interface_retrect-buttons-louvers__item .type_interface_retrect-buttons-louvers__input:checked ~ .type_interface__retrect-buttons-louvers__label .radio-circle::after, .type_interface_retrect-buttons-louvers__item.active .radio-circle::after {
  opacity: 1;
}
.type_interface_retrect-buttons-louvers__item .color-name {
  font-size: 14px;
  margin-left: 6px;
}

.type_interface__retrect-buttons-louvers__label {
  display: flex;
  align-items: center;
}

.type_interface_retrect-buttons-louvers__item.option.active {
  color: #629A33;
}

.portal-container {
  z-index: 101;
  position: absolute;
  top: 50%;
  right: 39vw;
  padding: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(71, 101, 147, 0.1);
  transform: translateX(calc(-100% - 10px));
  min-width: 244px;
}
.portal-container--wide {
  min-width: 281px;
}
.portal-container__title {
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  font-weight: 500;
}
.portal-container__title__sub-title {
  font-family: "Inter", serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  color: #629A33;
  margin-top: 20px;
}
.portal-container__description {
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 400;
}
.portal-container .colors_picker_button {
  width: 133px;
  height: 37px;
  cursor: pointer;
  padding: 10px 20px;
  color: #ffffff;
  font-family: "Inter", serif;
  border: none;
  outline: 0;
  background-color: #629A33;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  vertical-align: bottom;
  white-space: nowrap;
  vertical-align: bottom;
  transition: all 0.3s;
}
.portal-container .colors_picker_button--wide {
  width: 175px !important;
  padding: 10px;
}
.portal-container .colors_picker_button:hover {
  opacity: 0.5;
}
.portal-container__close {
  cursor: pointer !important;
  top: 12px;
  right: 12px;
  position: absolute;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  width: 14px;
  height: 14px;
  display: flex;
  transition: all 0.3s;
}
.portal-container__close:hover {
  transform: rotate(180deg);
}
.portal-container__range {
  margin: 16px 0;
  width: 204px;
}
.portal-container__remove {
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #629A33;
  text-decoration: underline;
  text-underline-offset: 4px;
  margin-bottom: 20px;
}
.portal-container .blocked-range {
  pointer-events: none;
  opacity: 0.5;
}
.portal-container .main_container {
  display: flex;
  gap: 20px;
  margin-top: 10px;
  margin-bottom: 20px;
}
.portal-container .main_container .text {
  font-family: "Inter", serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
}
.portal-container .radio__container {
  display: flex;
  list-style: none;
  gap: 16px;
}
.portal-container .radio__container__item {
  cursor: pointer;
  display: flex;
  gap: 6px;
}
.portal-container .radio__container__item__cyrcle {
  display: flex;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1px solid #629A33;
}
.portal-container .radio__container__item__text {
  font-family: "Inter", serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
}
.portal-container .radio__container__item.active .radio__container__item__cyrcle {
  display: flex;
  align-items: center;
  justify-content: center;
}
.portal-container .radio__container__item.active .radio__container__item__cyrcle::after {
  content: "";
  display: block;
  width: 50%;
  height: 50%;
  background-color: #629A33;
  border-radius: 50%;
}
.portal-container .radio__container__item.active .radio__container__item__text {
  color: #629A33;
}
.portal-container .canvas_menu_switch_container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.portal-container .switch-container {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-top: 16px;
}
.portal-container .switch-container-sign {
  width: 17px;
  height: 5px;
  background-color: #629A33;
  border-radius: 2px;
  transform: translateX(25%) rotate(90deg);
}
.portal-container #switchButton {
  width: 33px;
  height: 17px;
  border: none;
  outline: 0;
  -webkit-appearance: none;
  background-color: #629A33;
  border-radius: 100px;
  position: relative;
  align-items: center;
  display: flex;
  cursor: pointer;
}
.portal-container #switchButton-active::after {
  left: 5%;
}
.portal-container .switch-container-sign {
  width: 17px;
  height: 5px;
  background-color: #629A33;
  border-radius: 2px;
  transform: translateX(25%) rotate(90deg);
}
.portal-container .canvas_menu__title {
  font-family: "Inter", serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  vertical-align: bottom;
}
.portal-container .canvas_menu__title--blade-rotation {
  font-weight: 500;
}
.portal-container #blade-block-wrap {
  margin-top: 24px;
}

.portal-heaters {
  z-index: 11111;
  width: 290px;
  position: absolute;
  top: 50%;
  right: 39vw;
  padding: 20px;
  background-color: #ffffff;
  box-border: 0px 2px 10px 0px rgba(153, 122, 79, 0.3019607843);
}
.portal-heaters__title {
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  font-weight: 500;
  margin-bottom: 16px;
}
.portal-heaters__close {
  cursor: pointer !important;
  top: 12px;
  right: 12px;
  position: absolute;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  width: 16px;
  height: 16px;
  display: flex;
  transition: all 0.3s;
}
.portal-heaters__close:hover {
  transform: rotate(180deg);
}
.portal-heaters__range {
  margin: 16px 0;
}
.portal-heaters__remove {
  cursor: pointer;
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #629A33;
  text-decoration: underline;
  text-underline-offset: 4px;
}

.portal-screen {
  z-index: 11111;
  width: 290px;
  height: 70%;
  max-height: 540px;
  overflow: auto;
  position: absolute;
  top: 20%;
  right: 39vw;
  padding: 20px;
  background-color: #ffffff;
  box-border: 0px 2px 10px 0px rgba(153, 122, 79, 0.3019607843);
  -ms-overflow-style: none;
}
.portal-screen::-webkit-scrollbar {
  display: none;
}
.portal-screen__title {
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  font-weight: 500;
  margin-bottom: 16px;
}
.portal-screen__close {
  cursor: pointer !important;
  top: 12px;
  right: 12px;
  position: absolute;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  width: 16px;
  height: 16px;
  display: flex;
  transition: all 0.3s;
}
.portal-screen__close:hover {
  transform: rotate(180deg);
}
.portal-screen__remove {
  cursor: pointer;
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #629A33;
  text-decoration: underline;
  text-underline-offset: 4px;
}
.portal-screen__block {
  margin-bottom: 16px;
}
.portal-screen__block__title {
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  margin-bottom: 10px;
}
.portal-screen__block__list {
  list-style: none;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}
.portal-screen__block__list__item {
  cursor: pointer;
  width: 50px;
  height: fit-content;
}
.portal-screen__block__list__item--active {
  color: #629A33 !important;
}
.portal-screen__block__list__item--active .portal-screen__block__list__item__container {
  box-border: 0px 2px 10px 0px rgba(153, 122, 79, 0.3019607843);
}
.portal-screen__block__list__item__container {
  padding: 2px;
  background-color: #ffffff;
  box-border: 0px 2px 10px 0px #1A1A1A;
  border-radius: 10px;
  height: 50px;
  transition: all 0.3s;
}
.portal-screen__block__list__item__container:hover {
  transform: translateY(-5%);
}
.portal-screen__block__list__item__title {
  margin-top: 6px;
  font-family: "Inter", serif;
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.portal-screen__block-color {
  margin-bottom: 16px;
}
.portal-screen__block-color__title {
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  margin-bottom: 10px;
}
.portal-screen__block-color__list {
  list-style: none;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}
.portal-screen__block-color__list__item {
  cursor: pointer;
  width: 50px;
  height: fit-content;
}
.portal-screen__block-color__list__item--active {
  color: #629A33 !important;
}
.portal-screen__block-color__list__item--active .portal-screen__block-color__list__item__container {
  box-border: 0px 2px 10px 0px rgba(153, 122, 79, 0.3019607843);
}
.portal-screen__block-color__list__item__container {
  padding: 2px;
  background-color: #ffffff;
  box-border: 0px 2px 10px 0px #1A1A1A;
  border-radius: 10px;
  height: 50px;
  transition: all 0.3s;
}
.portal-screen__block-color__list__item__container:hover {
  transform: translateY(-5%);
}
.portal-screen__block-color__list__item__title {
  margin-top: 6px;
  font-family: "Inter", serif;
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}

.portal-shades {
  z-index: 11111;
  width: 290px;
  overflow: auto;
  position: absolute;
  top: 20%;
  right: 39vw;
  padding: 20px;
  background-color: #ffffff;
  box-border: 0px 2px 10px 0px rgba(153, 122, 79, 0.3019607843);
}
.portal-shades__title {
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  font-weight: 500;
  margin-bottom: 16px;
}
.portal-shades__close {
  cursor: pointer !important;
  top: 12px;
  right: 12px;
  position: absolute;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  width: 16px;
  height: 16px;
  display: flex;
  transition: all 0.3s;
}
.portal-shades__close:hover {
  transform: rotate(180deg);
}
.portal-shades__remove {
  cursor: pointer;
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #629A33;
  text-decoration: underline;
  text-underline-offset: 4px;
}
.portal-shades__block {
  margin-bottom: 16px;
}
.portal-shades__block__title {
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  margin-bottom: 10px;
}
.portal-shades__block__list {
  list-style: none;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}
.portal-shades__block__list__item {
  cursor: pointer;
  width: 50px;
  height: fit-content;
}
.portal-shades__block__list__item--active {
  color: #629A33 !important;
}
.portal-shades__block__list__item--active .portal-screen__block__list__item__container {
  box-border: 0px 2px 10px 0px rgba(153, 122, 79, 0.3019607843);
}
.portal-shades__block__list__item__container {
  padding: 2px;
  background-color: #ffffff;
  box-border: 0px 2px 10px 0px #1A1A1A;
  border-radius: 10px;
  height: 50px;
  transition: all 0.3s;
}
.portal-shades__block__list__item__container:hover {
  transform: translateY(-5%);
}
.portal-shades__block__list__item__title {
  margin-top: 6px;
  font-family: "Inter", serif;
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.portal-shades__block-color {
  margin-bottom: 16px;
}
.portal-shades__block-color__title {
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  margin-bottom: 10px;
}
.portal-shades__block-color__list {
  list-style: none;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}
.portal-shades__block-color__list__item {
  cursor: pointer;
  width: 50px;
  height: fit-content;
}
.portal-shades__block-color__list__item--active {
  color: #629A33 !important;
}
.portal-shades__block-color__list__item--active .portal-screen__block-color__list__item__container {
  box-border: 0px 2px 10px 0px rgba(153, 122, 79, 0.3019607843);
}
.portal-shades__block-color__list__item__container {
  padding: 2px;
  background-color: #ffffff;
  box-border: 0px 2px 10px 0px #1A1A1A;
  border-radius: 10px;
  height: 50px;
  transition: all 0.3s;
}
.portal-shades__block-color__list__item__container:hover {
  transform: translateY(-5%);
}
.portal-shades__block-color__list__item__title {
  margin-top: 6px;
  font-family: "Inter", serif;
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}

.button-pulse {
  border: 1px solid #629A33;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  background-color: #ffffff;
  cursor: pointer;
  animation: pulse-border 1.5s infinite;
}

@keyframes pulse-border {
  0% {
    box-shadow: 0 0 0 0 rgba(98, 154, 51, 0.6);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(98, 154, 51, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(98, 154, 51, 0);
  }
}
.sun__icon {
  cursor: pointer;
  border: 1px solid #629A33;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  background-color: #ffffff;
  cursor: pointer;
  animation: pulse-border 1.5s infinite;
}
.sun__icon__img {
  cursor: pointer;
  transition: all 0.3s;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 18px;
  height: 18px;
  display: flex;
}
.sun__icon__img:hover {
  transform: scale(1.1);
}
.sun__icon::after {
  content: attr(data-value);
  position: absolute;
  right: 20px;
  color: #629A33;
  border-radius: 3px;
  white-space: nowrap;
  text-align: right;
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  transition: all 0.3s;
  visibility: hidden;
  opacity: 0;
}
.sun__icon:hover::after {
  transform: translateX(-20px);
  visibility: visible;
  opacity: 1;
}

.icon_container-mobile {
  width: calc(85% - 32px) !important;
}

.icon_container {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  position: absolute;
  top: 20px;
  right: 20px;
}

.sun__icon-active--7 {
  background-color: #629A33;
  border-color: #629A33 !important;
}
.sun__icon-active--7 .sun__icon__img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
  width: 22px;
  height: 19px;
}

.sun__icon-active--6 {
  background-color: #629A33;
  border-color: #629A33 !important;
}
.sun__icon-active--6 .sun__icon__img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
  width: 22px;
  height: 22px;
}

.sun__icon-active--0 {
  background-color: #629A33;
  border-color: #629A33 !important;
  background-position: center;
}
.sun__icon-active--0 .sun__icon__img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) !important;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 32px;
  height: 32px;
  display: flex;
}

.sun__icon-active--2 {
  background-color: #629A33;
  border-color: #629A33 !important;
}
.sun__icon-active--2 .sun__icon__img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) !important;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 22px;
  height: 22px;
  display: flex;
}

.sun__icon-active--4 {
  background-color: #629A33;
  border-color: #629A33 !important;
}
.sun__icon-active--4 .sun__icon__img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) !important;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 22px;
  height: 22px;
  display: flex;
}

.sun__icon-active--1 {
  background-color: #629A33;
  border-color: #629A33 !important;
}
.sun__icon-active--1 .sun__icon__img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) !important;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 13px;
  height: 16px;
  display: flex;
}

.sun__icon-active--3 {
  background-color: #629A33;
  border-color: #629A33 !important;
}
.sun__icon-active--3 .sun__icon__img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) !important;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 22px;
  height: 22px;
  display: flex;
}

.sun__icon-active--8 {
  background-color: #629A33;
  border-color: #629A33 !important;
}

.sun__icon-active--10 {
  background-color: #629A33;
  border-color: #629A33 !important;
}
.sun__icon-active--10 .sun__icon__img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) !important;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 22px;
  height: 22px;
  display: flex;
}

#heaters-n {
  width: 17px;
  height: 17px;
}

#blade-range_wrap .range__label {
  display: none;
}

#blade-range_wrap {
  width: 204px;
  margin-top: 16px !important;
  margin-bottom: 0 !important;
}

#louvers-range_wrap .range__label {
  display: none;
}

#louvers-range_wrap {
  width: 204px;
  margin-top: 16px !important;
  margin-bottom: 0 !important;
}

.range__wrapper {
  margin-top: 24px;
}

#zip-range_wrap {
  margin-top: 24px;
}
#zip-range_wrap .range__label {
  display: none;
}
#zip-range_wrap .range__wrapper {
  height: auto !important;
}
#zip-range_wrap #range__thumb-value {
  transform: translateY(calc(-100% - 20px));
  color: #629A33;
}

#sliding-door-range_wrap {
  width: 245px;
}
#sliding-door-range_wrap .range__label {
  display: none;
}

#bi-s-rotate-range_wrap {
  min-width: 200px;
  margin-bottom: 0;
}
#bi-s-rotate-range_wrap .range__label {
  display: none;
}

#bi-s-open-range_wrap {
  min-width: 200px;
  margin-bottom: 0;
}
#bi-s-open-range_wrap .range__label {
  display: none;
}

#sl-open-range_wrap,
#sl-rotate-range_wrap {
  min-width: 200px;
  margin-bottom: 0;
}
#sl-open-range_wrap .range__label,
#sl-rotate-range_wrap .range__label {
  display: none;
}

#bs-open-range_wrap,
#bs-rotate-range_wrap {
  min-width: 200px;
  margin-bottom: 0;
}
#bs-open-range_wrap .range__label,
#bs-rotate-range_wrap .range__label {
  display: none;
}

#slats_radio {
  min-width: 200px;
  margin: 20px 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/portal/portals.scss","webpack://./src/styles/_mixins.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAIA;EACE,SAAA;EACA,oBAAA;EACA,mBAAA;AAHF;AAKE;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAHJ;AAME;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAJJ;AAQE;EACE,aAAA;EACA,YAAA;EACA,qCAAA;EACA,SAAA;EACA,uBAAA;AANJ;AASE;EACE,aAAA;EACA,SAAA;AAPJ;AAYM;EACE,mCAAA;AAVR;AAaM;EACE,YAAA;AAXR;AAiBQ;EACE,WAAA;ECnCR,qDAAA;EDsCQ,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAhBV;AAoBM;EACE,cE1DO;AFwCf;AAuBE;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;EAEA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AAtBJ;AAwBI;EACE,gBAAA;EACA,kBAAA;EC3EJ,2BAAA;ED8EI,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AAvBN;AA2BE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ECtFF,2BAAA;EDwFE,oBAAA;AAzBJ;AA2BI;EACE,WAAA;EACA,YAAA;ECpGJ,2BAAA;EDuGI,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AA1BN;;AA+BA;EACE,cEtHa;AF0Ff;;AAgCE;EACE,aAAA;EACA,SAAA;EACA,sBAAA;ECzHF,2BAAA;ED2HE,gBAAA;AA7BJ;AAgCE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AA9BJ;AAgCI;EACE,aAAA;AA9BN;AAiCI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;AA/BN;AAiCM;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBE1JO;EF2JP,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;EACA,wBAAA;AA/BR;AAmCI;EAEE,UAAA;AAlCN;AAqCI;EACE,eAAA;EACA,gBAAA;AAnCN;;AAwCA;EACE,aAAA;EACA,mBAAA;AArCF;;AAwCA;EACE,cEtLa;AFiJf;;AAwCA;EACE,YAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,yBE1LY;EDeZ,oDAAA;ED6KA,yCAAA;EAEA,gBAAA;AAtCF;AAwCE;EACE,gBAAA;AAtCJ;AAyCE;ECtKA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EDqKE,gBAAA;AApCJ;AAsCI;ECzMF,2BAAA;ED2MI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cElNS;EFmNT,gBAAA;AApCN;AAwCE;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAtCJ;AAyCE;EACE,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,cEhOU;EDDZ,2BAAA;EDmOE,YAAA;EACA,UAAA;EACA,yBEzOW;EF0OX,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EAEA,sBAAA;EACA,oBAAA;AAxCJ;AA0CI;EACE,uBAAA;EACA,aAAA;AAxCN;AA2CI;EACE,YAAA;AAzCN;AA6CE;EACE,0BAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;AA3CJ;AA6CI;EACE,yBAAA;AA3CN;AA+CE;EACE,cAAA;EACA,YAAA;AA7CJ;AAgDE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cEzRW;EF0RX,0BAAA;EACA,0BAAA;EACA,mBAAA;AA9CJ;AAkDE;EACE,oBAAA;EACA,YAAA;AAhDJ;AAmDE;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AAjDJ;AAmDI;ECvSF,2BAAA;EDySI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAjDN;AAqDE;EACE,aAAA;EACA,gBAAA;EACA,SAAA;AAnDJ;AAqDI;EACE,eAAA;EACA,aAAA;EACA,QAAA;AAnDN;AAqDM;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAnDR;AAsDM;EClUJ,2BAAA;EDoUM,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AApDR;AAwDQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAtDV;AAwDU;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,yBEzVG;EF0VH,kBAAA;AAtDZ;AA0DQ;EACE,cE/VK;AFuSf;AA8DE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AA5DJ;AA+DE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AA7DJ;AAgEE;EACE,WAAA;EACA,WAAA;EACA,yBEtXW;EFuXX,kBAAA;EACA,wCAAA;AA9DJ;AAiEE;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,wBAAA;EACA,yBEjYW;EFkYX,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AA/DJ;AAiEI;EACE,QAAA;AA/DN;AAmEE;EACE,WAAA;EACA,WAAA;EACA,yBEhZW;EFiZX,kBAAA;EACA,wCAAA;AAjEJ;AAoEE;ECjZA,2BAAA;EDmZE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AAlEJ;AAoEI;EACE,gBAAA;AAlEN;AAsEE;EACE,gBAAA;AApEJ;;AAwEA;EACE,cAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,yBEzaY;EF0aZ,6DAAA;AArEF;AAuEE;EC9YA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ED6YE,gBAAA;EACA,mBAAA;AAlEJ;AAqEE;EACE,0BAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;AAnEJ;AAqEI;EACE,yBAAA;AAnEN;AAuEE;EACE,cAAA;AArEJ;AAwEE;EACE,eAAA;EC3aF,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ED0aE,cEhdW;EFidX,0BAAA;EACA,0BAAA;AAnEJ;;AAuEA;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,yBE3dY;EF4dZ,6DAAA;EACA,wBAAA;AApEF;AAsEE;EACE,aAAA;AApEJ;AAuEE;ECrcA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EDocE,gBAAA;EACA,mBAAA;AAlEJ;AAqEE;EACE,0BAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;AAnEJ;AAqEI;EACE,yBAAA;AAnEN;AAuEE;EACE,eAAA;EC9dF,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ED6dE,cEngBW;EFogBX,0BAAA;EACA,0BAAA;AAlEJ;AAqEE;EACE,mBAAA;AAnEJ;AAqEI;ECxeF,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EDueI,mBAAA;AAhEN;AAmEI;EACE,gBAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;AAjEN;AAmEM;EACE,eAAA;EACA,WAAA;EACA,mBAAA;AAjER;AAmEQ;EACE,yBAAA;AAjEV;AAmEU;EACE,6DAAA;AAjEZ;AAqEQ;EACE,YAAA;EACA,yBEhiBI;EFiiBJ,oCAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;AAnEV;AAqEU;EACE,0BAAA;AAnEZ;AAuEQ;EACE,eAAA;EC7fR,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kCAAA;EACA,8BAAA;ADybF;AAqEE;EACE,mBAAA;AAnEJ;AAqEI;ECxhBF,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EDuhBI,mBAAA;AAhEN;AAmEI;EACE,gBAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;AAjEN;AAmEM;EACE,eAAA;EACA,WAAA;EACA,mBAAA;AAjER;AAmEQ;EACE,yBAAA;AAjEV;AAmEU;EACE,6DAAA;AAjEZ;AAqEQ;EACE,YAAA;EACA,yBEhlBI;EFilBJ,oCAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;AAnEV;AAqEU;EACE,0BAAA;AAnEZ;AAuEQ;EACE,eAAA;EC7iBR,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kCAAA;EACA,8BAAA;ADyeF;;AAsEA;EACE,cAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,yBE5mBY;EF6mBZ,6DAAA;AAnEF;AAqEE;ECjlBA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EDglBE,gBAAA;EACA,mBAAA;AAhEJ;AAmEE;EACE,0BAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;AAjEJ;AAmEI;EACE,yBAAA;AAjEN;AAqEE;EACE,eAAA;EC1mBF,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EDymBE,cE/oBW;EFgpBX,0BAAA;EACA,0BAAA;AAhEJ;AAmEE;EACE,mBAAA;AAjEJ;AAmEI;ECpnBF,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EDmnBI,mBAAA;AA9DN;AAiEI;EACE,gBAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;AA/DN;AAiEM;EACE,eAAA;EACA,WAAA;EACA,mBAAA;AA/DR;AAiEQ;EACE,yBAAA;AA/DV;AAiEU;EACE,6DAAA;AA/DZ;AAmEQ;EACE,YAAA;EACA,yBE5qBI;EF6qBJ,oCAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;AAjEV;AAmEU;EACE,0BAAA;AAjEZ;AAqEQ;EACE,eAAA;ECzoBR,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kCAAA;EACA,8BAAA;ADukBF;AAmEE;EACE,mBAAA;AAjEJ;AAmEI;ECpqBF,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EDmqBI,mBAAA;AA9DN;AAiEI;EACE,gBAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;AA/DN;AAiEM;EACE,eAAA;EACA,WAAA;EACA,mBAAA;AA/DR;AAiEQ;EACE,yBAAA;AA/DV;AAiEU;EACE,6DAAA;AA/DZ;AAmEQ;EACE,YAAA;EACA,yBE5tBI;EF6tBJ,oCAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;AAjEV;AAmEU;EACE,0BAAA;AAjEZ;AAqEQ;EACE,eAAA;ECzrBR,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kCAAA;EACA,8BAAA;ADunBF;;AAoEA;EACE,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,yBEvvBY;EFwvBZ,eAAA;EACA,qCAAA;AAjEF;;AAoEA;EACE;IACE,0CAAA;EAjEF;EAoEA;IACE,0CAAA;EAlEF;EAqEA;IACE,wCAAA;EAnEF;AACF;AAsEA;EACE,eAAA;EAEA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,yBEnxBY;EFoxBZ,eAAA;EACA,qCAAA;AArEF;AAuEE;EACE,eAAA;EACA,oBAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AArEJ;AAuEI;EACE,qBAAA;AArEN;AAyEE;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,cE/yBW;EFgzBX,kBAAA;EACA,mBAAA;EACA,iBAAA;ECxwBF,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,8BAAA;EDowBE,oBAAA;EACA,kBAAA;EACA,UAAA;AAjEJ;AAqEI;EACE,4BAAA;EACA,mBAAA;EACA,UAAA;AAnEN;;AAwEA;EACE,kCAAA;AArEF;;AAwEA;EACE,aAAA;EACA,0BAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AArEF;;AAwEA;EACE,yBEh1Ba;EFi1Bb,gCAAA;AArEF;AAuEE;EACE,oEAAA;EACA,WAAA;EACA,YAAA;AArEJ;;AAyEA;EACE,yBE31Ba;EF41Bb,gCAAA;AAtEF;AAwEE;EACE,oEAAA;EACA,WAAA;EACA,YAAA;AAtEJ;;AA0EA;EACE,yBEt2Ba;EFu2Bb,gCAAA;EACA,2BAAA;AAvEF;AAyEE;EACE,oEAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AAvEJ;;AA2EA;EACE,yBEt3Ba;EFu3Bb,gCAAA;AAxEF;AA0EE;EACE,oEAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AAxEJ;;AA4EA;EACE,yBEr4Ba;EFs4Bb,gCAAA;AAzEF;AA2EE;EACE,oEAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AAzEJ;;AA6EA;EACE,yBEp5Ba;EFq5Bb,gCAAA;AA1EF;AA4EE;EACE,oEAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AA1EJ;;AA8EA;EACE,yBEn6Ba;EFo6Bb,gCAAA;AA3EF;AA6EE;EACE,oEAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AA3EJ;;AA+EA;EACE,yBEl7Ba;EFm7Bb,gCAAA;AA5EF;;AAyFA;EACE,yBEj8Ba;EFk8Bb,gCAAA;AAtFF;AAwFE;EACE,oEAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AAtFJ;;AA0FA;EACE,WAAA;EACA,YAAA;AAvFF;;AA0FA;EACE,aAAA;AAvFF;;AA0FA;EACE,YAAA;EACA,2BAAA;EACA,2BAAA;AAvFF;;AA0FA;EACE,aAAA;AAvFF;;AA0FA;EACE,YAAA;EACA,2BAAA;EACA,2BAAA;AAvFF;;AA0FA;EACE,gBAAA;AAvFF;;AA0FA;EACE,gBAAA;AAvFF;AAyFE;EACE,aAAA;AAvFJ;AA0FE;EACE,uBAAA;AAxFJ;AA2FE;EACE,yCAAA;EACA,cEz/BW;AFg6Bf;;AA6FA;EACE,YAAA;AA1FF;AA4FE;EACE,aAAA;AA1FJ;;AA8FA;EACE,gBAAA;EACA,gBAAA;AA3FF;AA6FE;EACE,aAAA;AA3FJ;;AA+FA;EACE,gBAAA;EACA,gBAAA;AA5FF;AA8FE;EACE,aAAA;AA5FJ;;AAgGA;;EAEE,gBAAA;EACA,gBAAA;AA7FF;AA+FE;;EACE,aAAA;AA5FJ;;AAgGA;;EAEE,gBAAA;EACA,gBAAA;AA7FF;AA+FE;;EACE,aAAA;AA5FJ;;AAgGA;EACE,gBAAA;EACA,yBAAA;AA7FF","sourcesContent":["@use \"../../styles/mixins\" as mixins;\n@use \"../../styles/variables\" as vars;\n\n\n.colors_picker_container {\n  gap: 21px;\n  display: inline-flex;\n  align-items: center;\n\n  .colors_picker_color {\n    width: 50px;\n    height: 37px;\n    cursor: pointer;\n  }\n\n  .type_interface_colors-buttons-led {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-bottom: 20px;\n\n  }\n\n  .colors_container {\n    display: grid;\n    width: 113px;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 44px;\n    justify-content: center;\n  }\n\n  &__options {\n    display: flex;\n    gap: 16px;\n  }\n\n  &__item {\n    &--active {\n      &:hover {\n        transform: translateY(0) !important;\n      }\n\n      .image-container {\n        padding: 2px;\n        // @include mixins.box-border(\n        //   10,\n        //   rgba(vars.$second-color, 0.7) !important\n        // );\n\n        &::before {\n          content: \"\";\n          @include mixins.box-border(10,\n            rgba(vars.$second-color, 0.7) !important);\n          position: absolute;\n          width: 29px;\n          height: 29px;\n          border-radius: 50%;\n        }\n      }\n\n      .type_interface_colors-buttons-led__label {\n        color: vars.$second-color;\n      }\n    }\n  }\n\n  &__label {\n    display: flex;\n    flex-direction: column;\n    align-items: center !important;\n    cursor: pointer;\n    width: fit-content;\n\n    font-weight: 400;\n    font-size: 8px;\n    line-height: 120%;\n    letter-spacing: 0%;\n    text-align: center;\n    vertical-align: bottom;\n\n    .color-name {\n      margin-top: 10px;\n      text-align: center;\n      @include mixins.font-family;\n\n      font-weight: 400;\n      font-size: 8px;\n      line-height: 120%;\n      letter-spacing: 0%;\n      text-align: center;\n      vertical-align: bottom;\n    }\n  }\n\n  .image-container {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    padding: 3px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    @include mixins.box-border(10, vars.$black-color);\n    transition: all 0.3s;\n\n    .color-image {\n      width: 100%;\n      height: 100%;\n      @include mixins.font-family;\n\n      font-weight: 400;\n      font-size: 8px;\n      line-height: 120%;\n      letter-spacing: 0%;\n      text-align: center;\n      vertical-align: bottom;\n    }\n  }\n}\n\n.colorShade {\n  color: vars.$second-color;\n}\n\n.type_interface_retrect-buttons-louvers {\n  &__options {\n    display: flex;\n    gap: 16px;\n    flex-direction: column;\n    @include mixins.font-family;\n    margin-top: 16px;\n  }\n\n  &__item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    cursor: pointer;\n\n    .type_interface_retrect-buttons-louvers__input {\n      display: none;\n    }\n\n    .radio-circle {\n      width: 20px;\n      height: 20px;\n      border-radius: 50%;\n      border: 2px solid vars.$second-color;\n      display: inline-block;\n      position: relative;\n      flex-shrink: 0;\n\n      &::after {\n        content: '';\n        width: 10px;\n        height: 10px;\n        border-radius: 50%;\n        background: vars.$second-color;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        opacity: 0;\n        transition: opacity 0.2s;\n      }\n    }\n\n    .type_interface_retrect-buttons-louvers__input:checked~.type_interface__retrect-buttons-louvers__label .radio-circle::after,\n    &.active .radio-circle::after {\n      opacity: 1;\n    }\n\n    .color-name {\n      font-size: 14px;\n      margin-left: 6px;\n    }\n  }\n}\n\n.type_interface__retrect-buttons-louvers__label {\n  display: flex;\n  align-items: center;\n}\n\n.type_interface_retrect-buttons-louvers__item.option.active {\n  color: vars.$second-color;\n}\n\n.portal-container {\n  z-index: 101;\n  position: absolute;\n  top: 50%;\n  right: calc(vars.$width-interface);\n  padding: 20px;\n  background-color: vars.$white-color;\n  @include mixins.box-shadow(#47659314);\n  transform: translateX(calc(-100% - 10px));\n\n  min-width: 244px;\n\n  &--wide {\n    min-width: 281px;\n  }\n\n  &__title {\n    @include mixins.h3;\n    font-weight: 500;\n\n    &__sub-title {\n      @include mixins.font-family;\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 100%;\n      color: vars.$second-color;\n      margin-top: 20px;\n    }\n  }\n\n  &__description {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 24px;\n    margin-bottom: 16px;\n    font-size: 14px;\n    font-weight: 400;\n  }\n\n  .colors_picker_button {\n    width: 133px;\n    height: 37px;\n    cursor: pointer;\n    padding: 10px 20px;\n    color: vars.$white-color;\n    @include mixins.font-family();\n    border: none;\n    outline: 0;\n    background-color: vars.$second-color;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 120%;\n    letter-spacing: 0%;\n    vertical-align: bottom;\n    white-space: nowrap;\n\n    vertical-align: bottom;\n    transition: all 0.3s;\n\n    &--wide {\n      width: 175px !important;\n      padding: 10px;\n    }\n\n    &:hover {\n      opacity: 0.5;\n    }\n  }\n\n  &__close {\n    cursor: pointer !important;\n    top: 12px;\n    right: 12px;\n    position: absolute;\n    background-image: url(../../../public/img/icons/marevo-icon-close.svg);\n    background-repeat: no-repeat;\n    background-size: cover;\n    width: 14px;\n    height: 14px;\n    display: flex;\n    transition: all 0.3s;\n\n    &:hover {\n      transform: rotate(180deg);\n    }\n  }\n\n  &__range {\n    margin: 16px 0;\n    width: 204px;\n  }\n\n  &__remove {\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    color: vars.$second-color;\n    text-decoration: underline;\n    text-underline-offset: 4px;\n    margin-bottom: 20px;\n  }\n\n\n  .blocked-range {\n    pointer-events: none;\n    opacity: 0.5;\n  }\n\n  .main_container {\n    display: flex;\n    gap: 20px;\n    margin-top: 10px;\n    margin-bottom: 20px;\n\n    .text {\n      @include mixins.font-family;\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 100%;\n      letter-spacing: 0%;\n    }\n  }\n\n  .radio__container {\n    display: flex;\n    list-style: none;\n    gap: 16px;\n\n    &__item {\n      cursor: pointer;\n      display: flex;\n      gap: 6px;\n\n      &__cyrcle {\n        display: flex;\n        width: 14px;\n        height: 14px;\n        border-radius: 50%;\n        border: 1px solid vars.$second-color;\n      }\n\n      &__text {\n        @include mixins.font-family;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 100%;\n        letter-spacing: 0%;\n      }\n\n      &.active {\n        .radio__container__item__cyrcle {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n\n          &::after {\n            content: \"\";\n            display: block;\n            width: 50%;\n            height: 50%;\n            background-color: vars.$second-color;\n            border-radius: 50%;\n          }\n        }\n\n        .radio__container__item__text {\n          color: vars.$second-color;\n        }\n      }\n    }\n  }\n\n  .canvas_menu_switch_container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n  }\n\n  .switch-container {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    margin-top: 16px;\n  }\n\n  .switch-container-sign {\n    width: 17px;\n    height: 5px;\n    background-color: vars.$second-color;\n    border-radius: 2px;\n    transform: translateX(25%) rotate(90deg);\n  }\n\n  #switchButton {\n    width: 33px;\n    height: 17px;\n    border: none;\n    outline: 0;\n    -webkit-appearance: none;\n    background-color: vars.$second-color;\n    border-radius: 100px;\n    position: relative;\n    align-items: center;\n    display: flex;\n    cursor: pointer;\n\n    &-active::after {\n      left: 5%;\n    }\n  }\n\n  .switch-container-sign {\n    width: 17px;\n    height: 5px;\n    background-color: vars.$second-color;\n    border-radius: 2px;\n    transform: translateX(25%) rotate(90deg);\n  }\n\n  .canvas_menu__title {\n    @include mixins.font-family();\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 120%;\n    letter-spacing: 0%;\n    vertical-align: bottom;\n\n    &--blade-rotation {\n      font-weight: 500;\n    }\n  }\n\n  #blade-block-wrap {\n    margin-top: 24px;\n  }\n}\n\n.portal-heaters {\n  z-index: 11111;\n  width: 290px;\n  position: absolute;\n  top: 50%;\n  right: calc(vars.$width-interface);\n  padding: 20px;\n  background-color: vars.$white-color;\n  box-border: 0px 2px 10px 0px #997a4f4d;\n\n  &__title {\n    @include mixins.h3;\n    font-weight: 500;\n    margin-bottom: 16px;\n  }\n\n  &__close {\n    cursor: pointer !important;\n    top: 12px;\n    right: 12px;\n    position: absolute;\n    background-image: url(../../../public/img/icons/marevo-icon-close.svg);\n    background-repeat: no-repeat;\n    background-size: cover;\n    width: 16px;\n    height: 16px;\n    display: flex;\n    transition: all 0.3s;\n\n    &:hover {\n      transform: rotate(180deg);\n    }\n  }\n\n  &__range {\n    margin: 16px 0;\n  }\n\n  &__remove {\n    cursor: pointer;\n    @include mixins.h3;\n    color: vars.$second-color;\n    text-decoration: underline;\n    text-underline-offset: 4px;\n  }\n}\n\n.portal-screen {\n  z-index: 11111;\n  width: 290px;\n  height: 70%;\n  max-height: 540px;\n  overflow: auto;\n  position: absolute;\n  top: 20%;\n  right: calc(vars.$width-interface);\n  padding: 20px;\n  background-color: vars.$white-color;\n  box-border: 0px 2px 10px 0px #997a4f4d;\n  -ms-overflow-style: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  &__title {\n    @include mixins.h3;\n    font-weight: 500;\n    margin-bottom: 16px;\n  }\n\n  &__close {\n    cursor: pointer !important;\n    top: 12px;\n    right: 12px;\n    position: absolute;\n    background-image: url(../../../public/img/icons/marevo-icon-close.svg);\n    background-repeat: no-repeat;\n    background-size: cover;\n    width: 16px;\n    height: 16px;\n    display: flex;\n    transition: all 0.3s;\n\n    &:hover {\n      transform: rotate(180deg);\n    }\n  }\n\n  &__remove {\n    cursor: pointer;\n    @include mixins.h3;\n    color: vars.$second-color;\n    text-decoration: underline;\n    text-underline-offset: 4px;\n  }\n\n  &__block {\n    margin-bottom: 16px;\n\n    &__title {\n      @include mixins.h3;\n      margin-bottom: 10px;\n    }\n\n    &__list {\n      list-style: none;\n      display: grid;\n      grid-template-columns: repeat(4, 1fr);\n      gap: 16px;\n\n      &__item {\n        cursor: pointer;\n        width: 50px;\n        height: fit-content;\n\n        &--active {\n          color: vars.$second-color !important;\n\n          .portal-screen__block__list__item__container {\n            box-border: 0px 2px 10px 0px #997a4f4d;\n          }\n        }\n\n        &__container {\n          padding: 2px;\n          background-color: vars.$white-color;\n          box-border: 0px 2px 10px 0px vars.$black-color;\n          border-radius: 10px;\n          height: 50px;\n          transition: all 0.3s;\n\n          &:hover {\n            transform: translateY(-5%);\n          }\n        }\n\n        &__title {\n          margin-top: 6px;\n          @include mixins.h5();\n        }\n      }\n    }\n  }\n\n  &__block-color {\n    margin-bottom: 16px;\n\n    &__title {\n      @include mixins.h3;\n      margin-bottom: 10px;\n    }\n\n    &__list {\n      list-style: none;\n      display: grid;\n      grid-template-columns: repeat(4, 1fr);\n      gap: 16px;\n\n      &__item {\n        cursor: pointer;\n        width: 50px;\n        height: fit-content;\n\n        &--active {\n          color: vars.$second-color !important;\n\n          .portal-screen__block-color__list__item__container {\n            box-border: 0px 2px 10px 0px #997a4f4d;\n          }\n        }\n\n        &__container {\n          padding: 2px;\n          background-color: vars.$white-color;\n          box-border: 0px 2px 10px 0px vars.$black-color;\n          border-radius: 10px;\n          height: 50px;\n          transition: all 0.3s;\n\n          &:hover {\n            transform: translateY(-5%);\n          }\n        }\n\n        &__title {\n          margin-top: 6px;\n          @include mixins.h5();\n        }\n      }\n    }\n  }\n}\n\n.portal-shades {\n  z-index: 11111;\n  width: 290px;\n  overflow: auto;\n  position: absolute;\n  top: 20%;\n  right: calc(vars.$width-interface);\n  padding: 20px;\n  background-color: vars.$white-color;\n  box-border: 0px 2px 10px 0px #997a4f4d;\n\n  &__title {\n    @include mixins.h3;\n    font-weight: 500;\n    margin-bottom: 16px;\n  }\n\n  &__close {\n    cursor: pointer !important;\n    top: 12px;\n    right: 12px;\n    position: absolute;\n    background-image: url(../../../public/img/icons/marevo-icon-close.svg);\n    background-repeat: no-repeat;\n    background-size: cover;\n    width: 16px;\n    height: 16px;\n    display: flex;\n    transition: all 0.3s;\n\n    &:hover {\n      transform: rotate(180deg);\n    }\n  }\n\n  &__remove {\n    cursor: pointer;\n    @include mixins.h3;\n    color: vars.$second-color;\n    text-decoration: underline;\n    text-underline-offset: 4px;\n  }\n\n  &__block {\n    margin-bottom: 16px;\n\n    &__title {\n      @include mixins.h3;\n      margin-bottom: 10px;\n    }\n\n    &__list {\n      list-style: none;\n      display: grid;\n      grid-template-columns: repeat(4, 1fr);\n      gap: 16px;\n\n      &__item {\n        cursor: pointer;\n        width: 50px;\n        height: fit-content;\n\n        &--active {\n          color: vars.$second-color !important;\n\n          .portal-screen__block__list__item__container {\n            box-border: 0px 2px 10px 0px #997a4f4d;\n          }\n        }\n\n        &__container {\n          padding: 2px;\n          background-color: vars.$white-color;\n          box-border: 0px 2px 10px 0px vars.$black-color;\n          border-radius: 10px;\n          height: 50px;\n          transition: all 0.3s;\n\n          &:hover {\n            transform: translateY(-5%);\n          }\n        }\n\n        &__title {\n          margin-top: 6px;\n          @include mixins.h5();\n        }\n      }\n    }\n  }\n\n  &__block-color {\n    margin-bottom: 16px;\n\n    &__title {\n      @include mixins.h3;\n      margin-bottom: 10px;\n    }\n\n    &__list {\n      list-style: none;\n      display: grid;\n      grid-template-columns: repeat(4, 1fr);\n      gap: 16px;\n\n      &__item {\n        cursor: pointer;\n        width: 50px;\n        height: fit-content;\n\n        &--active {\n          color: vars.$second-color !important;\n\n          .portal-screen__block-color__list__item__container {\n            box-border: 0px 2px 10px 0px #997a4f4d;\n          }\n        }\n\n        &__container {\n          padding: 2px;\n          background-color: vars.$white-color;\n          box-border: 0px 2px 10px 0px vars.$black-color;\n          border-radius: 10px;\n          height: 50px;\n          transition: all 0.3s;\n\n          &:hover {\n            transform: translateY(-5%);\n          }\n        }\n\n        &__title {\n          margin-top: 6px;\n          @include mixins.h5();\n        }\n      }\n    }\n  }\n}\n\n.button-pulse {\n  border: 1px solid vars.$second-color;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 32px;\n  height: 32px;\n  background-color: vars.$white-color;\n  cursor: pointer;\n  animation: pulse-border 1.5s infinite;\n}\n\n@keyframes pulse-border {\n  0% {\n    box-shadow: 0 0 0 0 rgba(vars.$second-color, 0.6);\n  }\n\n  70% {\n    box-shadow: 0 0 0 8px rgba(vars.$second-color, 0);\n  }\n\n  100% {\n    box-shadow: 0 0 0 0 rgba(vars.$second-color, 0);\n  }\n}\n\n.sun__icon {\n  cursor: pointer;\n\n  border: 1px solid vars.$second-color;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 32px;\n  height: 32px;\n  background-color: vars.$white-color;\n  cursor: pointer;\n  animation: pulse-border 1.5s infinite;\n\n  &__img {\n    cursor: pointer;\n    transition: all 0.3s;\n    background-repeat: no-repeat;\n    background-size: contain;\n    background-position: center;\n    width: 18px;\n    height: 18px;\n    display: flex;\n\n    &:hover {\n      transform: scale(1.1);\n    }\n  }\n\n  &::after {\n    content: attr(data-value);\n    position: absolute;\n    right: 20px;\n    color: vars.$second-color;\n    border-radius: 3px;\n    white-space: nowrap;\n    text-align: right;\n    @include mixins.h4;\n    transition: all 0.3s;\n    visibility: hidden;\n    opacity: 0;\n  }\n\n  &:hover {\n    &::after {\n      transform: translateX(-20px);\n      visibility: visible;\n      opacity: 1;\n    }\n  }\n}\n\n.icon_container-mobile {\n  width: calc(85% - 32px) !important;\n}\n\n.icon_container {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 20px;\n  position: absolute;\n  top: 20px;\n  right: 20px;\n}\n\n.sun__icon-active--7 {\n  background-color: vars.$second-color;\n  border-color: vars.$second-color !important;\n\n  .sun__icon__img {\n    background-image: url(../../../public/img/icons/mood-light-active.svg) !important;\n    width: 22px;\n    height: 19px;\n  }\n}\n\n.sun__icon-active--6 {\n  background-color: vars.$second-color;\n  border-color: vars.$second-color !important;\n\n  .sun__icon__img {\n    background-image: url(../../../public/img/icons/led-light-active.svg) !important;\n    width: 22px;\n    height: 22px;\n  }\n}\n\n.sun__icon-active--0 {\n  background-color: vars.$second-color;\n  border-color: vars.$second-color !important;\n  background-position: center;\n\n  .sun__icon__img {\n    background-image: url(../../../public/img/icons/marevo-menu-sliding.svg) !important;\n    background-repeat: no-repeat;\n    background-size: contain;\n    background-position: center;\n    width: 32px;\n    height: 32px;\n    display: flex;\n  }\n}\n\n.sun__icon-active--2 {\n  background-color: vars.$second-color;\n  border-color: vars.$second-color !important;\n\n  .sun__icon__img {\n    background-image: url(../../../public/img/icons/marevo-menu-blinds-active.svg) !important;\n    background-repeat: no-repeat;\n    background-size: contain;\n    background-position: center;\n    width: 22px;\n    height: 22px;\n    display: flex;\n  }\n}\n\n.sun__icon-active--4 {\n  background-color: vars.$second-color;\n  border-color: vars.$second-color !important;\n\n  .sun__icon__img {\n    background-image: url(../../../public/img/icons/marevo-menu-shutters-sliding-active.svg) !important;\n    background-repeat: no-repeat;\n    background-size: contain;\n    background-position: center;\n    width: 22px;\n    height: 22px;\n    display: flex;\n  }\n}\n\n.sun__icon-active--1 {\n  background-color: vars.$second-color;\n  border-color: vars.$second-color !important;\n\n  .sun__icon__img {\n    background-image: url(../../../public/img/icons/marevo-menu-shutters-sliding-active.svg) !important;\n    background-repeat: no-repeat;\n    background-size: contain;\n    background-position: center;\n    width: 13px;\n    height: 16px;\n    display: flex;\n  }\n}\n\n.sun__icon-active--3 {\n  background-color: vars.$second-color;\n  border-color: vars.$second-color !important;\n\n  .sun__icon__img {\n    background-image: url(../../../public/img/icons/marevo-menu-door-sliding-glass-active.svg) !important;\n    background-repeat: no-repeat;\n    background-size: contain;\n    background-position: center;\n    width: 22px;\n    height: 22px;\n    display: flex;\n  }\n}\n\n.sun__icon-active--8 {\n  background-color: vars.$second-color;\n  border-color: vars.$second-color !important;\n\n  // .sun__icon__img {\n  //   background-image: url(../../../public/img/icons/chaya-white-icons/fixed-slats.svg) !important;\n  //   background-repeat: no-repeat;\n  //   background-size: contain;\n  //   background-position: center;\n  //   width: 22px;\n  //   height: 22px;\n  //   display: flex;\n  // }\n}\n\n.sun__icon-active--10 {\n  background-color: vars.$second-color;\n  border-color: vars.$second-color !important;\n\n  .sun__icon__img {\n    background-image: url(../../../public/img/icons/marevo-menu-roof-settings-active.svg) !important;\n    background-repeat: no-repeat;\n    background-size: contain;\n    background-position: center;\n    width: 22px;\n    height: 22px;\n    display: flex;\n  }\n}\n\n#heaters-n {\n  width: 17px;\n  height: 17px;\n}\n\n#blade-range_wrap .range__label {\n  display: none;\n}\n\n#blade-range_wrap {\n  width: 204px;\n  margin-top: 16px !important;\n  margin-bottom: 0 !important;\n}\n\n#louvers-range_wrap .range__label {\n  display: none;\n}\n\n#louvers-range_wrap {\n  width: 204px;\n  margin-top: 16px !important;\n  margin-bottom: 0 !important;\n}\n\n.range__wrapper {\n  margin-top: 24px;\n}\n\n#zip-range_wrap {\n  margin-top: 24px;\n\n  .range__label {\n    display: none;\n  }\n\n  .range__wrapper {\n    height: auto !important;\n  }\n\n  #range__thumb-value {\n    transform: translateY(calc(-100% - 20px));\n    color: vars.$second-color;\n  }\n}\n\n#sliding-door-range_wrap {\n  width: 245px;\n\n  .range__label {\n    display: none;\n  }\n}\n\n#bi-s-rotate-range_wrap {\n  min-width: 200px;\n  margin-bottom: 0;\n\n  .range__label {\n    display: none;\n  }\n}\n\n#bi-s-open-range_wrap {\n  min-width: 200px;\n  margin-bottom: 0;\n\n  .range__label {\n    display: none;\n  }\n}\n\n#sl-open-range_wrap,\n#sl-rotate-range_wrap {\n  min-width: 200px;\n  margin-bottom: 0;\n\n  .range__label {\n    display: none;\n  }\n}\n\n#bs-open-range_wrap,\n#bs-rotate-range_wrap {\n  min-width: 200px;\n  margin-bottom: 0;\n\n  .range__label {\n    display: none;\n  }\n}\n\n#slats_radio {\n  min-width: 200px;\n  margin: 20px 0 !important;\n}","@use \"variables\" as vars;\n\n@mixin text-center {\n  text-align: center;\n}\n\n@mixin font-family {\n  font-family: \"Inter\", serif;\n}\n\n@mixin font-family-second {\n   font-family: \"Inter\", serif;\n}\n\n@mixin box-border($blur, $color) {\n  border: 0.5px solid $color;\n}\n\n@mixin box-border-solid($blur, $color) {\n  border: 1px solid $color;\n}\n\n@mixin box-shadow($color) {\n  box-shadow: 0px 0px 20px 0px rgba($color, 0.1);\n}\n\n@mixin radius() {\n  border-radius: 10px;\n}\n\n@mixin h2() {\n  font-family: \"Inter\", serif;\n  font-weight: 300;\n  font-size: 17px;\n  line-height: 100%;\n}\n\n@mixin h3() {\n  font-family: \"Inter\", serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n}\n\n@mixin h4() {\n  font-family: \"Inter\", serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n\n@mixin h5() {\n  font-family: \"Inter\", serif;\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  text-align: center;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n\n@mixin bold {\n  font-family: \"Inter\", serif;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 12px;\n}\n","$primary-color: #629A33;\n$secondary-color: #6c757d;\n$font-size-base: 16px;\n$second-color: #629A33;\n$second-color-1: #06aeef;\n$shadow-color: #47659314;\n$black-color:  #1A1A1A;\n$black-color-second: #3A3A3C;\n$white-color: #ffffff;\n$red-color: #ff214a;\n\n$margin-top-title-option: 10px;\n$padding-vertical-group-inputs: 20px;\n$width-interface: 39vw;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
